var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"age-slider"},[_c('div',{ref:"slider"})])
}
var staticRenderFns = []

export { render, staticRenderFns }